import React from 'react'
import CN from './ComputerNetwork.pdf';
import SQL from './SQL.pdf';
import DB from './DB.jpg';
import Face from './CN.png';
import {Helmet} from 'react-helmet';


export default function Assignment() {
  return (
    <div className='mx-10 my-10'>

<Helmet>
  <meta charSet="utf-8" />
  <title>Projects Nabeel-R</title>
  <link rel="canonical" href="http://nabeel-r.netlify.app/projects" />
  <meta name="description" content="Nabeel-R: Check out my Tech work. My expertise is in technology. I am passionate about technology. I am proficient in ML, Web Dev, Coding, Data Science." />
</Helmet>
<center>
<h1 className='white title'>Projects</h1>
</center>
<br/><br/>
<div className='grid lg:grid-cols-2 md:grid-cols-1 grid-cols-1 '>

<center>
<div className='lg:col-span-1 w-full'>

<a href={SQL} className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src={DB} alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 white">SQL</h5>
        <p className="mb-3 font-normal white dark:text-gray-400">
<br/>
I have Acute knowledge of SQL & Database Management.<br/>View SQL Lab work & Assignments performed by me.
<br/>
</p>
</div>
</a>
<br/>

<a href="https://nabeel-r.vercel.app" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl ">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://images.unsplash.com/photo-1542435503-956c469947f6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YmxvZ2dpbmd8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 white">Blog Website</h5>
        <p className="mb-3 font-normal white dark:text-gray-400">
<br/>Programming Languages Used: HTML, CSS, JavaScript, Python<br/><br/>
Tools Used: Django, Github, Git, VSCode, Cloudinary Cloud, PostgreSQL DB, Vercel<br/></p>
</div>
</a>
<br/>
<a href="https://play.google.com/store/apps/details?id=com.nabeelr.app" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://play-lh.googleusercontent.com/7RPP3o6Im9BTqtEHntg4ey1-dHhoTVjCAGnpatEiuImhY9fxmAUoi-MySRH3TW3sIAgc=w240-h480-rw" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">Go Metro Lucknow</h5>
        <p className="mb-3 font-normal white">
            <br />
            I developed the app using React Native to enhance the metro travel experience in Lucknow. The app provides essential features such as fare details, route maps, platform information, nearest stations, etc, ensuring a seamless and convenient journey for users. It is hosted on the Play Store using Google Play Console.
            <br/>
        <br/>Programming Languages Used: React Native, JSX, VSCode, Google Play Console, Expo<br/><br/>
</p>    </div>
</a>
<br/>

<a href="https://nabeel-rizwan.github.io/Windows/" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://images.unsplash.com/photo-1632239776255-0a7f24814df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWljcm9zb2Z0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">Windows Frontend</h5>
        <p className="mb-3 font-normal white">
            <br/>
            Programming Languages Used: HTML, CSS, JavaScript<br/><br/>
    
    Note- Works only laptop only
Tools Used: Github, Git, VSCode<br/>
</p>    </div>
</a>
<br/>

</div>      { /* End of Grid left */}

</center>



<div className='lg:col-span-1 w-full'>

<center>

<a href="https://github.com/Nabeel-Rizwan/ProductIf" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">ProductIf</h5>
        <p className="mb-3 font-normal white">

<br/>
Programming Languages & Tools Used: JSX, React Native, Git/Github
<br/><br/>
Developed a Job search app using React Native which shows jobs from Germany, USA and UK. It also provides job insights by displaying top companies hiring for a particular role.

        </p>
    </div>
</a>
<br/>
    

<a href="https://github.com/Nabeel-Rizwan/Attendance-using-Face-Recognition.git" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src={Face} alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">Attendance Using Face</h5>
        <p className="mb-3 font-normal white">
<br/>
Detects real & fake faces.
<br/><br/>
Programming Languages & Tools Used: Python, VSCode, Git, Github.
<br/><br/>
Algorithms Used: CNN, Liveness Model, Viola Jones


        </p>
    </div>
</a>
<br/>

<a href={CN} className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://royalsociety.org/-/media/policy/projects/digital-technology-and-the-planet/digital-tech-and-the-planet.jpg?w=300" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">Computer Networks</h5>
        <p className="mb-3 font-normal white">
<br/>
View Computer Network Lab work & Assignments performed by me using python programming language and encryptions.
<br/>
</p>
</div>
</a>
<br/>

<a href="https://github.com/Nabeel-Rizwan/Voice-Assistant-Mac.git" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg lg:h-50 md:h-50 md:w-48 h-50 md:rounded-none md:rounded-s-lg" src="https://images.unsplash.com/photo-1605648916361-9bc12ad6a569?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">Voice Assistant</h5>
        <p className="mb-3 font-normal white">
<br/>
        Programming Language & Tools Used: Python, Git, Github, VSCode<br/>
        
        </p>
    </div>
</a>
<br/><br/>

<a href="https://chatnote.netlify.app/" className="dark flex flex-col items-center rounded-lg shadow md:flex-row md:max-w-xl">
    <img className="object-cover w-full rounded-t-lg  md:h-50 lg:h-50 h-50 md:w-48 md:rounded-none md:rounded-s-lg" src="https://images.unsplash.com/photo-1585435516476-bd92c7d4d9b2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight white">ChatNote</h5>
        <p className="mb-3 font-normal white">
<br/>
        Programming Language Used: JSX  <br/><br/>
         Tools Used: ReactJS, Git, Github, VSCode, Firebase
         <br/>
        </p>
    </div>
</a>
<br/>


</center>
</div>

</div> { /* End of Grid */ }

<br />
<br />

<p className='white'> * Please refer github and linkedin for more projects developed by me</p>

    </div>
  )
}
